var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62435 0.791748C6.62435 0.44657 6.34453 0.166748 5.99935 0.166748C5.65417 0.166748 5.37435 0.44657 5.37435 0.791748V5.37508H0.791016C0.445838 5.37508 0.166016 5.6549 0.166016 6.00008C0.166016 6.34526 0.445838 6.62508 0.791016 6.62508H5.37435V11.2084C5.37435 11.5536 5.65417 11.8334 5.99935 11.8334C6.34453 11.8334 6.62435 11.5536 6.62435 11.2084V6.62508H11.2077C11.5529 6.62508 11.8327 6.34526 11.8327 6.00008C11.8327 5.6549 11.5529 5.37508 11.2077 5.37508H6.62435V0.791748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f2e88661a943768cfaaa3ced8b741683.svg";
export { ForwardRef as ReactComponent };